import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import {ListController} from "./ListController";
import {ManageController} from "./ManageController";
import {XheoDebugLogController} from "./XheoDebugLogController";
import {XheoExtensionController} from "./XheoExtensionController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('license', {abstract: true})
            .state('license.list', {
                url: '/license/list',
                template: require('./List.html'),
                controller: ListController,
                controllerAs: 'vm',
                data: {title: 'Asset List'}
            })
            .state('license.manage', {
                url: '/license/{assetGuid}/manage?create',
                params: {
                    assetGuid: {value: null},
                    create: {value: null}
                },
                template: require('./Manage.html'),
                controller: ManageController,
                controllerAs: 'vm',
                data: {title: 'Manage Asset'}
            })
            .state('license.debug', {
                url: '/license/{licenseNumber}/debug',
                template: require('./XheoDebugLog.html'),
                controller: XheoDebugLogController,
                controllerAs: 'vm',
                data: {title: 'Xheo Debug Log'}
            })
            .state('license.extension', {
                url: '/license/extension',
                template: require('./XheoExtension.html'),
                controller: XheoExtensionController,
                controllerAs: 'vm',
                data: {title: 'Xheo Extensions'}
            })


    }
}

export default angular.module('app.license', [])
    .config(Routes)
    .name;
